<template>
<!-- 省市区 -->
    <div class="modal" :class="modalClass" v-show="showMask">
        <div class="modal-bg" @click="closeMask" v-if="iscloseMask"></div>
        <div class="modal-bg" v-else></div>
        <div class="modal-content" ref="monthPie" :style="widthStyle">
            <!-- <div class="modal-header" style="" v-if="title!=''">
                <span class="">{{title}}</span>
                <a class="close fr" heaf="javascript:void(0);" @click="closeMask">&times;</a>
            </div> -->
            <div class="modal-content2">
              <div class="modal-warp ac">
                  <slot name="mdBox"></slot>
              </div>
              <div class="modal-footer ac" v-if="modalFoot">
                  <div class="sig" v-if="type == 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                  </div>
                  <div v-if="type != 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                      <button class="btn btn-none" id="closeModal" @click="closeMask">{{cancelText}}</button>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dialog",
    props:{
        iscloseMask:{
          type:Boolean,
          default: false,
        },
        modalClass:{
            type:String,
            default:function(){
                return 'defModal';
            },
        },
        title:{
            type:String,
            default:function(){
                return '';
            },
        },
        width:{
            type:String,
            default:function(){
                return '90';
            },
        },
        type:{
            type:String,
            default:function(){
                return 'normal';
            },
        },
        modalFoot:{
            type:Boolean,
            default: true,
        },
        btnText:{
            type:String,
            default:function(){
                return 'YES';
            },
        },
        cancelText:{
            type:String,
            default:function(){
                return 'sure';
            },
        },
        callback:{
            type:Function
        }
    },
    data() {
        return {
            showMask: false,
            timer:'',
            loadText:'loading...',
            widthStyle:'',
            height:'',
        }
    },
    mounted() {
        // this.showMask = this.value;
        // this.widthStyle = 'width:'+this.width+'%;margin-left:-'+this.width/2+'%';
        this.widthStyle = 'width:'+this.width+'%;';
    },
    created() {

    },
    methods: {
        //打开弹框
        showMaskFun () {
            let that = this;
            that.showMask = true;
        },
        closeMask(){
            // clearInterval(this.timer);
            this.showMask = false;
            this.height = '';
        },
        dangerBtn(){
            let that = this;
            // if(that.load == true){
            //     return;
            // }
            /*if(that.type === 'alert'){
                this.showMask = false;
                return;
            }*/
            let num = 0;
            this.callback();
            // setTimeout(() => {
            //     if(this.dialogShow == true){
            //         this.closeMask();
            //     }
            // }, 1);
        }
    }
}
</script>
<style scoped>
/* 遮罩层 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.modal-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
}

/* 弹窗内容 */
.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  /* 居中 */
  background: #fff;
  border-radius: 20px;
  padding: 30px 20px;
  max-width: 90%;   /* 最大宽度 */
  width: 400px;     /* 默认宽度 */
  max-height: 80vh; /* 限制最大高度 */
  overflow-y: auto; /* 超出滚动 */
  box-sizing: border-box;
}

/* 头部 */
.modal-header {
  color: #333;
  font-size: 22px;
  padding: 10px 0;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  text-align: center;
}
.modal-header .close {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 28px;
  height: 28px;
  border: 1px solid #666;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 200;
  text-align: center;
  line-height: 26px;
  color: #414141;
  cursor: pointer;
}

/* 主体 */
.modal-warp {
  padding: 20px 0;
  font-size: 16px;
  color: #333;
  text-align: center;
}

/* 底部按钮 */
.modal-footer {
  padding: 20px 0 10px;
  text-align: center;
}
.modal-footer .btn {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px;
  background-color: #d46902;
  width: 80%;
  max-width: 280px;
  box-shadow: none;
  cursor: pointer;
}

/* 特殊 letModal 用法 */
.letModal .modal-content {
  height: auto;       /* 取消写死高度 */
  max-height: 85vh;   /* 自适应屏幕 */
}
.letModal .modal-footer .btn {
  background-color: #f3bb4d;
  position: static;   /* 去掉绝对定位 */
  margin: 20px auto 0;
}
</style>




// WEBPACK FOOTER //
// src/components/dialog.vue